import {
  MessageResponseDto,
  GetMemberDto,
  CreateMemberDto,
  EditMemberDto,
  MemberControllerGet200Response,
  MemberApiFp,
  DeleteMemberDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseMemberModel = MemberControllerGet200Response;
export type GetMemberModel = GetMemberDto & Partial<{ fileBlob: any }>;
export type MutateResponseMemberModel = MessageResponseDto;
export type CreateMemberModel = CreateMemberDto;
export type UpdateMemberModel = EditMemberDto;
export type DeleteMemberModel = DeleteMemberDto;

export interface CreateMemberModelExtension {
  member: CreateMemberModel;
  file: File;
}

export interface UpdateMemberModelExtension {
  member: UpdateMemberModel;
  file: File;
}

export const apiMemberFp = MemberApiFp(apiConfig);
export const getMemberController = apiMemberFp.memberControllerGet;
export const getAllMemberController = apiMemberFp.memberControllerAll;
export const getChildrenMemberController = apiMemberFp.memberControllerGetChildren;
export const getParentMemberController = apiMemberFp.memberControllerGetParent;
export const createMemberController = apiMemberFp.memberControllerCreate;
export const updateMemberController = apiMemberFp.memberControllerEdit;
export const deleteMemberController = apiMemberFp.memberControllerDelete;

export const QueryKeyMember = QueryKey.Member;
